import { partners } from "@/mocks/partners";

export default function Partners() {
  return (
    <section
      id="partners"
      className="w-full bg-background-100 py-10 md:py-12 lg:py-14"
    >
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-8 md:mb-10">
          <p className="text-xs font-semibold tracking-widest uppercase text-primary-600 mb-4">
            Collaboration
          </p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            Our Partners
          </h2>
        </div>

        {/* Partners Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {partners.map((partner) => (
            <a
              key={partner.name}
              href={partner.website}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex flex-col items-center text-center bg-background-50 border border-background-200/70 rounded-lg p-8 hover:border-primary-300/60 transition-colors"
            >
              <h3 className="text-lg font-heading font-semibold text-foreground-950 mb-2">
                {partner.name}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {partner.description}
              </p>
              <span className="mt-4 inline-flex items-center gap-1 text-xs font-medium text-primary-600 group-hover:text-primary-700 transition-colors">
                Visit website
                <i className="ri-external-link-line" />
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}